import { MountApproveByCalculators } from '../approve-by-calculator';
import { MountIdentifierLists } from '../identifier-list';

main();

function main() {
    MountIdentifierLists(document);
    MountApproveByCalculators(document);
}
